import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import Exports from 'modules/attendance/components/ClockIn/Modals/Exports'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'

const EmployeeExportsModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { employeeId } = useStrictParams<'year' | 'month' | 'day' | 'employeeId' | 'periodType'>()
  const { pathParams } = useAttendanceDateNavigator()

  const onClose = () => {
    navigate(
      navigation.timeTracking.employee.periodTypeYearMonthDayEmployeeId.fullPath({
        ...pathParams,
        employeeId,
      })
    )
  }

  return <Exports employeeId={Number(employeeId)} onClose={onClose} />
}

export default EmployeeExportsModalPage
